<template>
    <Card :header="$t('logs')" class="m-0 shadow-none h-100">
        <template #nav>
            <ButtonIcon @click="fetchLogs()">{{ $t('loadLogs') }}</ButtonIcon>
        </template>
        <DataTable
            :fields="fields"
            :items="items"
            :loading="request.getLoading()"
            :error="request.getError()"
            :total-rows="max"
            :current-page.sync="tableParams.page"
            :per-page.sync="tableParams.perPage"
            :sort-by.sync="tableParams.sort"
            :sort-direction.sync="tableParams.order"
            no-sort-reset
            no-local-sorting
        >
            <template #cell(timestamp)="{ item }">
                {{ $format.dateAndHour(item.timestamp) }}
            </template>
            <template #cell(updatedAt)="{ item }">
                {{ $format.dateAndHour(item.updatedAt) }}
            </template>
            <template #cell(type)="{ item }">
                {{ item.type?.value }}
            </template>
            <template #cell(lastInFeedAt)="{ item }">
                {{ $format.dateAndHour(item.lastInFeedAt) }}
            </template>
        </DataTable>
    </Card>
</template>

<script>
    import Card from '@/components/common/Card.vue';
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'Logs',
        components: {
            Card,
            DataTable,
        },
        data() {
            return {
                request: this.$req('offers/logs'),
                tableParams: {
                    page: 1,
                    perPage: 10,
                    sort: 'timestamp',
                    order: 'desc',
                },
            };
        },
        computed: {
            offerId() {
                return Number(this.$route.params.id);
            },
            items() {
                return this.request.getData()?.items || [];
            },
            max() {
                return this.request.getData()?.max || 0;
            },
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'updatedAt', label: this.$t('updatedAt') },
                    { key: 'lastInFeedAt', label: this.$t('lastInFeedAt') },
                    { key: 'url', label: this.$t('url') },
                    { key: 'ean', label: this.$t('ean') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'info', label: this.$t('info') },
                    { key: 'code', label: this.$t('code') },
                    { key: 'price', label: this.$t('price') },
                    { key: 'feed', label: this.$t('feed') },
                    { key: 'offerId', label: this.$t('offerId') },
                    { key: 'active', label: this.$t('active') },
                    { key: 'hidden', label: this.$t('hidden') },
                    { key: 'type', label: this.$t('type') },
                ];
            },
        },
        watch: {
            tableParams: {
                deep: true,
                handler() {
                    this.fetchLogs();
                },
            },
        },
        methods: {
            fetchLogs() {
                this.request.get({
                    urlParams: { offerId: this.offerId },
                    requestParams: this.tableParams,
                    cache: false,
                });
            },
        },
    };
</script>
